class StickySummary extends HTMLElement {
  constructor() {
    super();
    this.placeholder = document.querySelector('.sticky-summary-placeholder');
    document.addEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    if (window.scrollY >= this.placeholder.offsetTop) {
      this.classList.add('sticky');
    } else {
      this.classList.remove('sticky');
    }
  }
}

customElements.define("sticky-summary", StickySummary);